import React, { createContext, ReactNode, useContext, useState } from 'react';

import { Currency } from '../../../../common/models/enums/currency.enum';
import { MoneyAmount } from '../../../../utils/money';
import { DepositItemModel } from '../../model/deposit-item-model';
import { DepositModel } from '../../model/deposit-model';
import { ErrorDepositItemResponse } from '../../model/error-deposit-item-response';

interface DepositResultContextState {
  deposit: DepositModel;
  successItems: DepositItemModel[];
  failureItems: ErrorDepositItemResponse[];
  setDepositResult: (
    deposit: DepositModel,
    successItems: DepositItemModel[],
    failureItems: ErrorDepositItemResponse[],
  ) => void;
  resetDepositResult: () => void;
}

const initialState: DepositResultContextState = {
  deposit: { amount: MoneyAmount.fromMinUnits(0), currency: Currency.EUR, expiryDays: null },
  successItems: [],
  failureItems: [],
  setDepositResult: () => {},
  resetDepositResult: () => {},
};

const DepositResultContext = createContext<DepositResultContextState>(initialState);

export const useDepositResultContext = () => useContext(DepositResultContext);

interface DepositResultContextProviderProps {
  children: ReactNode;
}

export const DepositResultContextProvider = ({ children }: DepositResultContextProviderProps) => {
  const [deposit, setDeposit] = useState<DepositModel>(initialState.deposit);
  const [successItems, setSuccessItems] = useState<DepositItemModel[]>([]);
  const [failureItems, setFailureItems] = useState<ErrorDepositItemResponse[]>([]);

  const setDepositResult = (
    depositResult: DepositModel,
    successItemsResult: DepositItemModel[],
    failureItemsResult: ErrorDepositItemResponse[],
  ) => {
    setDeposit(depositResult);
    setSuccessItems(successItemsResult);
    setFailureItems(failureItemsResult);
  };

  const resetDepositResult = () => {
    setDeposit(initialState.deposit);
    setSuccessItems([]);
    setFailureItems([]);
  };

  return (
    <DepositResultContext.Provider
      value={{
        deposit,
        successItems,
        failureItems,
        setDepositResult,
        resetDepositResult,
      }}
    >
      {children}
    </DepositResultContext.Provider>
  );
};
